import { useTranslation } from 'react-i18next';
import eleve from "../../../img/symbols/eleve.svg";
import leger from "../../../img/symbols/leger.svg";
import faible from "../../../img/symbols/faible.svg";
import modere from "../../../img/symbols/modere.svg";
import tresEleve from "../../../img/symbols/tres-eleve.svg";

/**
 * Renders the "Symboles de risque :" row (clickable green link + 5 icons).
 *
 * Note: this component does NOT render the top "Légende :" header anymore.
 * Callers that want it as a card with the header should use `RiskLegendCard`
 * (the canonical wrapper, used on every fiche detail page). Search-result
 * pages render their own "Légende :" because they group several legends
 * (e.g. ProductLegends, TreatmentLegends) under a single shared header —
 * having it inside this component would cause a duplicate "Légende :".
 *
 * @param {Object} props
 * @param {string} [props.title] - Optional custom link text (defaults to "Symboles de risque :")
 */
const RiskSymbolsLegends = ({ title }) => {
    const { t } = useTranslation('common');

    const legend = [
        { label: t('legends.risk.low'), image: faible },
        { label: t('legends.risk.light'), image: leger },
        { label: t('legends.risk.moderate'), image: modere },
        { label: t('legends.risk.high'), image: eleve },
        { label: t('legends.risk.extremelyHigh'), image: tresEleve }
    ];

    const riskLinkTitle = title || t('legends.risk.title');    // "Symboles de risque :" by default
    // Strip trailing colon/spaces from the title for the link text — we
    // append the colon manually so it sits inside the underline-on-hover area.
    const riskLinkText = riskLinkTitle.replace(/\s*:\s*$/, '');

    return (
        <div className="flex gap-6 items-center flex-wrap">
            <span className="text-[16px] font-bold">
                <a
                    href="/symboles-de-risque/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#105235] hover:underline"
                >
                    {riskLinkText} :
                </a>
            </span>
            <div className="flex gap-3 flex-wrap items-start">
                {legend.map((item, index) => (
                    <div key={index} className="flex flex-col gap-1 items-center">
                        <img src={item.image} alt={item.label} className="w-8 h-8" />
                        <span className="text-[12px] max-w-[80px] leading-tight text-center text-black">
                            {item.label}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RiskSymbolsLegends;